import { Box } from '@factorialco/deprecated-design-system'

import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

import CostCentersField from './CostCentersField'
import DescriptionField from './DescriptionField'
import InternalReferenceField from './InternalReferenceField'

interface Props extends PermissionsProps, CustomizationProps {
  hasCostCentersFeature: boolean
}

const AdditionalInformation = (props: Props) => {
  const { expensable, hasCostCentersFeature } = props

  return (
    <Box gap="s24">
      <DescriptionField {...props} fieldIdentifier="description" />
      <InternalReferenceField {...props} fieldIdentifier="internal_reference" />
      {!hasCostCentersFeature && expensable && expensable.owner?.id && expensable?.effectiveOn && (
        <CostCentersField {...props} expensable={expensable} fieldIdentifier="cost_centers" />
      )}
    </Box>
  )
}

export default AdditionalInformation
